import type { DivisionEntity, PageSummaryDto } from "@citychallenge/api-public";

export interface QRMatch {
  ID: string;
  STORY_ID?: string;
  PAGE_ID?: string;
  HIT_ID?: string;
  ALWAYS_RESTART?: boolean | null;
  LANG?: string | null;
  VARIABLES?: string | null;
  ENABLE_KIOSK_MODE?: boolean | null;
}

export interface WebConfig {
  API_URL: string;
  ENVIRONMENT_NAME: string;
  MAPBOX_ACCESS_TOKEN: string;
  DIVISION_INFO?: DivisionEntity;
  QR_ACCESSIBLE: boolean;
  QR_MATCH?: QRMatch;
  IS_CATCH_ALL_DOMAIN: boolean;
  STORAGE_TYPE: "persistent" | "session";
  PRIVACY_MODE: "strict" | "loose" | "dynamic";
  /**
   * Workspace page index (sitemap metadata), server-injected so the pages
   * runtime can register all routes and resolve the menu/home/links without a
   * first-paint fetch. Absent for non-workspace projects and when the
   * server-side fetch fails — the client then fetches it itself.
   */
  PAGES_INDEX?: { language: string; entries: PageSummaryDto[] };
  /** Whether the project's pages ask for consent, as the server decided. */
  ASKS_CONSENT: boolean;
}

declare global {
  interface Window {
    __INTRACTIVE_CONFIG?: WebConfig;
  }
}

const config: Partial<WebConfig> = window.__INTRACTIVE_CONFIG || {};

export const WEB_CONFIG: WebConfig = {
  API_URL: config.API_URL || "http://localhost:3001",
  ENVIRONMENT_NAME: config.ENVIRONMENT_NAME || "intractive",
  // REACT_APP_ fallback serves the CRA dev server, which has no SSR-injected config
  MAPBOX_ACCESS_TOKEN:
    config.MAPBOX_ACCESS_TOKEN ||
    process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ||
    "",
  DIVISION_INFO: config.DIVISION_INFO || undefined,
  STORAGE_TYPE: config.STORAGE_TYPE || ("persistent" as const),
  PRIVACY_MODE: config.PRIVACY_MODE || ("loose" as const),
  IS_CATCH_ALL_DOMAIN:
    typeof config.IS_CATCH_ALL_DOMAIN !== "undefined"
      ? config.IS_CATCH_ALL_DOMAIN
      : true,
  QR_ACCESSIBLE:
    typeof config.QR_ACCESSIBLE === "undefined" ? true : config.QR_ACCESSIBLE,
  QR_MATCH: config.QR_MATCH || undefined,
  PAGES_INDEX: config.PAGES_INDEX || undefined,
  ASKS_CONSENT: config.ASKS_CONSENT ?? false,
};
